

































































import Vue from "vue";
import { DrugApi, VueTableRequest } from "@/api";
import stateMixin from "@/mixins/state";
import _ from "lodash";
import { downloadCsvDocument, downloadDocument } from "@/util/download";

export default Vue.extend({
  data() {
    return {
      data: {},
      headers: [
        { text: "Naam", value: "longName" },
        { text: "GPK", value: "gpk" },
        { text: "PRK", value: "prk" },
        { text: "HPK", value: "hpk" },
        { text: "ZI", value: "ziNumber" },
        { text: "Uiterlijk", value: "dtaDescription" },
        { text: "Kan gehalveerd", value: "splitDescription", sortable: false },
        { text: "In primaire verpakking", value: "packaging" }
      ],
      options: {
        sortBy: ["longName"],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 20
      },
      searchQuery: ""
    };
  },
  name: "Products",
  mixins: [stateMixin],
  methods: {
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new DrugApi();
      try {
        const request: VueTableRequest = {
          sortBy: this.options.sortBy,
          descending: this.options.sortDesc,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage,
          search: this.searchQuery
        };
        const { data } = await api.drugGetDrugTable(request);
        this.data = data;

        this.data.items.map(
          i =>
            (i.splitDescription =
              i.splitDescription.indexOf("ERROR") > -1 ? "Nee" : "Ja")
        );

        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    downloadCsvDocument,
    downloadDocument,
    async downloadCsv() {
      const api = new DrugApi();
      try {
        const file = await api.drugExportAssortmentToCsv({
          responseType: "arraybuffer"
        });
        var responseFileName = file.headers["content-disposition"]
          .split("filename=")[1]
          .split(";")[0];
        this.downloadCsvDocument(file, responseFileName);
      } catch (err) {
        //TODO set correct state to display download error. After rebase with 220
        this.setState(this.states.ERROR);
      }
    },
    async downloadExcel() {
      const api = new DrugApi();
      try {
        const file = await api.drugExportAssortmentToExcel(
          {},
          {
            responseType: "arraybuffer"
          }
        );
        this.downloadDocument(file.data, file.headers);
      } catch (err) {
        //TODO set correct state to display download error. After rebase with 220
        this.setState(this.states.ERROR);
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true,
      immediate: false
    },
    searchQuery: _.debounce(function() {
      this.options.page = 1;
      this.fetch();
    }, 1000)
  }
});
